import { CommonEnums } from '../../common.enums';
import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Hbase_Inst } from './hbase_inst';
import { Conn_Db_Obj_LnksUtil } from '../../utils/conn_db_obj_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from '../../utils/dxflow_obj_properties.util';
import { Obj_Db_PropertyUtil } from '../../utils/obj_db_property.util';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';

export class Hbase {
    hbase_Inst: Hbase_Inst;
    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: number;
    hbase_Properties: Array<Obj_Db_Property>;
    target_Properties: Array<Obj_Db_Property>;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.hbase_Inst = new Hbase_Inst();
        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd=CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.LONG_VAL;
        this.hbase_Properties = new Array<Obj_Db_Property>();
        this.target_Properties = new Array<Obj_Db_Property>();
    }

    static parse(hbaseTmp: Hbase): Hbase {
        let hbase: Hbase = new Hbase();
        hbase.copyFrom(hbaseTmp);
        return hbase;
    }

    copy(): Hbase {
        let hbaseTmp: Hbase = new Hbase();

        hbaseTmp.hbase_Inst = this.hbase_Inst.copy();
        hbaseTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);
        hbaseTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties)
        hbaseTmp.change_Ind = this.change_Ind;
        hbaseTmp.error_Msg = this.error_Msg;
        hbaseTmp.error_Cd=this.error_Cd;
        hbaseTmp.ref_Id = this.ref_Id;
        hbaseTmp.ref_Cd = this.ref_Cd;
        hbaseTmp.hbase_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.hbase_Properties);
        hbaseTmp.target_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.target_Properties);

        return hbaseTmp;
    }

    copyFrom(hbaseTmp: Hbase): void {
        this.hbase_Inst.copyFrom(hbaseTmp.hbase_Inst);
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, hbaseTmp.conn_Db_Obj_Lnks);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, hbaseTmp.dxFlow_Obj_Properties);
        this.change_Ind = hbaseTmp.change_Ind
        this.error_Msg = hbaseTmp.error_Msg;
        this.error_Cd = hbaseTmp.error_Cd;
        this.ref_Id = hbaseTmp.ref_Id;
        this.ref_Cd = hbaseTmp.ref_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.hbase_Properties, hbaseTmp.hbase_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.target_Properties, hbaseTmp.target_Properties);
    }

    compare(hbaseTmp: Hbase): string {
        let diffString ='';
        diffString =(this.hbase_Inst).compare(hbaseTmp.hbase_Inst)
        if (diffString != '') return diffString;

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, hbaseTmp.conn_Db_Obj_Lnks);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.hbase_Properties, hbaseTmp.hbase_Properties);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.target_Properties, hbaseTmp.target_Properties);
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Hbase [hbase_Inst=" + this.hbase_Inst.toString() +
        ",error_Cd="+ this.error_Cd +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ", mongoDB_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.hbase_Properties) +
            ", target_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.target_Properties);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", error_Msg=" + this.error_Msg +
                ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd;
        }

        str += "]";
        return str;
    }
}